<script lang="ts">

    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { launchLoader, stopLoader } from '../scripts/utils';
    import { redirectTo } from '../scripts/router1';
    import { storeLoader, storeLanguage, lang_fr } from '../scripts/store';
    import { idPageHome, idPageLogin, namePageUserAccount, idPageResetPassword } from '../scripts/router2';
    import { updateUser, getActiveMembers, getUser } from '../scripts/apiUsers';
    import { storeEnterprises, storeEnterprisesError } from '../scripts/enterprise';
    import { storeUserLogin, storeUsers } from '../scripts/user';
    import { addNotificationError }  from "../scripts/toaster";
    import { getEnterprises } from '../scripts/apiEnterprises';

    let id = 0;
    let email: string = "";
    let password: string = "";
    let first_name: string = "";
    let last_name: string = "";
    let photo: string = "";
    let linkedin: string = "";
    let twitter: string = "";
    let enterprise: number = -1;
    let job: string = "";

    onMount(async () => {
        getEnterprisesIfEmpty();
        window.scrollTo(0,0);
        id = $storeUserLogin.id;
        email = $storeUserLogin.email;
        password = "";
        first_name = $storeUserLogin.first_name;
        last_name = $storeUserLogin.last_name;
        photo = $storeUserLogin.photo;
        linkedin = $storeUserLogin.linkedin;
        twitter = $storeUserLogin.twitter;
        enterprise = $storeUserLogin.enterprise;
        job = $storeUserLogin.job;
	});

        /**
     * getEnterprisesIfEmpty
     */
     function getEnterprisesIfEmpty() {
        if ($storeEnterprises.length <= 0) {
            launchLoader();
            const returnValue = getEnterprises();
            returnValue.then((data) => {
                stopLoader();
                if (!data) {
                    addNotificationError($storeEnterprisesError);
                };
            });
        }
    }

    /**
     * modifyUser
     */
    function modifyUser() {
        let files = (<HTMLInputElement> document.getElementById("idPhoto")).files;
        if (checkData(files[0])) {
            launchLoader();
            const isModify = updateUser(id, first_name, last_name, files[0], linkedin, twitter, enterprise, job);
            isModify.then((data) => {
                if (data == "200"){
                    const updateMembers = getActiveMembers();
                    const returnValue = getUser(id);
                        returnValue.then((data) => {
                            if (data){
                                redirectTo(idPageHome);
                            }
                        });
                } else if (data == "409") {
                    redirectTo(idPageLogin);
                }
                stopLoader();
            })
        }
    }

    /**
     * checkData
     * @param photoFile
     */
    function checkData(photoFile) {
        let isChecked: boolean = true;

        if (first_name == undefined || first_name == "") {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("Merci de renseigner le prénom");
            } else {
                addNotificationError("Please fill in the first name");
            }
            isChecked = false;
        }
        if (last_name == undefined || last_name == "") {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("Merci de renseigner le nom");
            } else {
                addNotificationError("Please fill in the last name");
            }
            isChecked = false;
        }
        if (linkedin != undefined && linkedin != "" && !validateUrl(linkedin)) {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("URL linkedin incorrecte");
            } else {
                addNotificationError("Invalid linkedin URL");
            }
            isChecked = false;
        }
        if (twitter != undefined && twitter != "" && !validateUrl(twitter)) {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("URL twitter incorrecte");
            } else {
                addNotificationError("Invalid twitter URL");
            }
            isChecked = false;
        }
        if (enterprise == undefined || enterprise < 0) {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("Merci de sélectionner une entreprise");
            } else {
                addNotificationError("Please select a company");
            }
            isChecked = false;
        }
        if (job == undefined || job == "") {
            if ($storeLanguage == $lang_fr) {
                addNotificationError("Merci de renseigner la fonction");
            } else {
                addNotificationError("Please fill in the function");
            }
            isChecked = false;
        }
        if (photoFile != undefined && photoFile != "") {
            if (photoFile.size > 1048576) {
                if ($storeLanguage == $lang_fr) {
                    addNotificationError("La photo doit avoir une taille inférieure à 1Mo");
                } else {
                    addNotificationError("Photo size must be less than 1Mo");
                }
                isChecked = false;
            }
        }
        return isChecked;
    }

	function validateUrl(url) {
        var urlPattern = new RegExp('https://www\.[A-Za-z0-9]+\.[A-Za-z0-9]+');
	    return urlPattern.test(url);
	}

</script>
    
<style lang="scss">

    .useraccount {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        margin: 0 0 40px 0;
        &__bloc {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            margin: 40px 0 0 0;
        }
        &__input {
            margin: 0 0 40px 0;
            border: 1px solid $color_orange;
            background-color: $color_primary;
            color: $color_white;
            border-radius: 5px;
            &::placeholder {
                color: $color_white;
                font-style: italic;
                opacity: 0.5;
            }
            &::file-selector-button {
                background: linear-gradient(to right, $color_primary, $color_orange);
                border-radius: 2px;
                color: $color_white;
                cursor: pointer;
                border: 1px solid $color_white;
            }
            &__disabled {
                opacity: 0.7;
            }
        }
        &__select {
            margin: 0 0 40px 0;
            background-color: $color_primary;
            border: 1px solid $color_orange;
            color: $color_white;
            border-radius: 5px;
            &::placeholder {
                color: $color_white;
                font-style: italic;
            }
        }
        &__photo {
            border-radius: 50%;
            padding: 8px 8px 8px 8px;
            width: 300px;
            height: 300px;
            align-self: center;
            margin: 0 0 50px 0;
            object-fit: cover;
        }
        &__link {
            color: $color_primary;
            margin: 0 0 40px 0;
        }
        &__note {
            font-style: italic;
            font-size: 12px;
        }
    }



    @include large {

        .useraccount {
            &__bloc {
                width: 40%;
                align-items: stretch;
            }
            &__link {
                cursor: pointer;
            }
        }
    }

</style>

<div class="useraccount">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props={namePageUserAccount}/>
    {:else}
    <PageHeader props="User account"/>
    {/if}
    {#if ($storeLanguage == $lang_fr)}
    <form class="bloc useraccount__bloc">
        <img class="useraccount__photo" src="../assets/images/users/{$storeUserLogin.id}_{$storeUserLogin.photo}" title="Profil" alt="profil">
        <label for="photo">Photo de profil (taille &lt; 1 MO)</label>
        <input class="useraccount__input font" type="file" name="photo" id="idPhoto" placeholder="photo" bind:value={photo}>
        <label for="email">Adresse email</label>
        <input class="useraccount__input useraccount__input__disabled font" type="email" name="email" readonly bind:value={email}>
        <label for="password">Mot de passe</label>
        <div class="useraccount__note">pour une meilleure sécurité, la modification du mot de passe suit la procédure de réinitialisation et validation par mail</div>
        <div class="useraccount__link" on:click={() => redirectTo(idPageResetPassword)} on:keydown={() => redirectTo(idPageResetPassword)}>Modifier le mot de passe</div>
        <label for="first_name">Prénom</label>
        <input class="useraccount__input font" type="text" name="first_name" placeholder="prénom" bind:value={first_name}>
        <label for="last_name">Nom</label>
        <input class="useraccount__input font" type="text" name="last_name" placeholder="nom" bind:value={last_name}>
        <label for="linkedin">Linkedin</label>
        <input class="useraccount__input font" type="text" name="linkedin" placeholder="https://www.linkedin ..." bind:value={linkedin}>
        <label for="twitter">Twitter</label>
        <input class="useraccount__input font" type="text" name="twitter" placeholder="https://www.twitter ..." bind:value={twitter}>
        <label for="enterprise">Entreprise</label>
        <select class="useraccount__select" name="enterprise" placeholder="sélectionner une entreprise" bind:value={enterprise}>
            <option value=99>-- aucune --</option>
            {#each $storeEnterprises as oneEnterprise}
            <option value={oneEnterprise.id}>{oneEnterprise.name}</option>                
            {/each}
        </select>
        <label for="job">Fonction</label>
        <input class="useraccount__input font" type="text" name="job" placeholder="fonction" bind:value={job}>
    </form>
    <input class="button" type="submit" on:click={modifyUser} value="Modification">
    {:else}
    <form class="bloc useraccount__bloc">
        <img class="useraccount__photo" src="../assets/images/users/{$storeUserLogin.id}_{$storeUserLogin.photo}" title="Profil" alt="profil">
        <label for="photo">Profil picture (size &lt; 1 MO)</label>
        <input class="useraccount__input font" type="file" name="photo" id="idPhoto" placeholder="photo" bind:value={photo}>
        <label for="email">Email adress</label>
        <input class="useraccount__input useraccount__input__disabled font" type="email" name="email" readonly bind:value={email}>
        <label for="password">Password</label>
        <div class="useraccount__note">for better security, changing the password follows the reset and validation procedure by email</div>
        <div class="useraccount__link" on:click={() => redirectTo(idPageResetPassword)} on:keydown={() => redirectTo(idPageResetPassword)}>Modify password</div>
        <label for="first_name">First name</label>
        <input class="useraccount__input font" type="text" name="first_name" placeholder="first name" bind:value={first_name}>
        <label for="last_name">Last name</label>
        <input class="useraccount__input font" type="text" name="last_name" placeholder="last name" bind:value={last_name}>
        <label for="linkedin">Linkedin</label>
        <input class="useraccount__input font" type="text" name="linkedin" placeholder="https://www.linkedin ..." bind:value={linkedin}>
        <label for="twitter">Twitter</label>
        <input class="useraccount__input font" type="text" name="twitter" placeholder="https://www.twitter ..." bind:value={twitter}>
        <label for="enterprise">Company</label>
        <select class="useraccount__select" name="enterprise" placeholder="select a company" bind:value={enterprise}>
            <option value=99>-- none --</option>
            {#each $storeEnterprises as oneEnterprise}
            <option value={oneEnterprise.id}>{oneEnterprise.name}</option>                
            {/each}
        </select>
        <label for="job">Function</label>
        <input class="useraccount__input font" type="text" name="job" placeholder="function" bind:value={job}>
    </form>
    <input class="button" type="submit" on:click={modifyUser} value="Modify">
    {/if}
</div>

